/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/media-has-caption */
// @flow
import * as React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { analytics } from 'common/utils/ga';

import * as css from './MainContent.scss';

type Props = {|
	checklistInfo: ChecklistsItem,
	itemInfo: GalleryItemInfo,
|};

type State = {
	isOpened: boolean,
};

class ExpandText extends React.PureComponent<Props, State> {
	state = {
		isOpened: false,
	};

	onOpenClick = () => {
		const { itemInfo } = this.props;
		const nameForAnalytics = _.get(itemInfo, 'nameForAnalytics', '');
		analytics.gtag.event('Click more info', { Event_Label: nameForAnalytics });
		this.setState({
			isOpened: true,
		});
	};

	onCloseClick = () => {
		this.setState({
			isOpened: false,
		});
	};

	render() {
		const { checklistInfo, itemInfo } = this.props;
		const { isOpened } = this.state;

		const text = _.get(itemInfo, 'infoText', '');
		const expandedBg = _.get(checklistInfo, 'graphics.backgroundColorForExpandedText', '#000');
		const isBlackColorItemBottomArea = _.get(checklistInfo, 'graphics.isBlackColorForBottomTextArea', false);
		return (
			<div className={classNames(css.expandTextWrapper)}>
				{text && (
					<>
						<div className={classNames(css.shortText, isOpened && css.closed)}>
							<div
								className={css.shortTextWrapper}
								style={{ color: isBlackColorItemBottomArea ? '#000' : '#fff' }}
							>
								{text}
							</div>
							{text.length > 101 && (
								<div className={css.openBtn} onClick={this.onOpenClick}>
									<span style={{ color: isBlackColorItemBottomArea ? '#000' : '#fff' }}>
										קרא/י עוד
									</span>
								</div>
							)}
						</div>
						<div
							className={classNames(css.expandText, isOpened && css.opened)}
							style={{ backgroundColor: expandedBg }}
						>
							<p style={{ color: isBlackColorItemBottomArea ? '#000' : '#fff' }}>{text}</p>
							<div
								style={{ color: isBlackColorItemBottomArea ? '#000' : '#fff' }}
								className={css.closeBtn}
								onClick={this.onCloseClick}
							>
								סגירה
							</div>
						</div>
					</>
				)}
			</div>
		);
	}
}

export default ExpandText;
